import { render, staticRenderFns } from "./Medicamentos.vue?vue&type=template&id=a9818f30&scoped=true&"
import script from "./Medicamentos.vue?vue&type=script&lang=js&"
export * from "./Medicamentos.vue?vue&type=script&lang=js&"
import style0 from "./Medicamentos.vue?vue&type=style&index=0&id=a9818f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9818f30",
  null
  
)

export default component.exports